const tag = {
  en: {
    tag: {
      labels: {
        actions: 'Actions',
        tag: 'Tag | Tags',
        privateTag: 'Private Tag',
        tagName: 'Tag Name:',
        tagId: 'Tag ID:',
        tagChild: 'Tag / Children',
        hierarchies: 'Hierarchies',
        associations: 'Associations', 
        parent_tags: 'Parent Tags',
        child_tags: 'Child Tags',
        created_at: 'Created At',
        created_by: 'Created By',
        updated_at: 'Updated At',
        updated_by: 'Updated By',
        updated_by_or_created_by: 'Updated By or Created By',
        both: 'Both',
        search_in: 'Search in',
        clear_user_filter: 'Clear user filter',
        total_results: 'Total Results',
        add_association: 'Add Association',
        no_associations: 'There are no associations.',
        export_associations: 'Export Associations',
        filter_by_date: 'Filter by Date',
        name: {
          title: "Name"
        },
        tags: {
          title: "Tags",
          select: "Select a Tag",
          multi_select: "Select Tags"
        },
        exclude_tags: {
          title: "Excluded Tag | Excluded Tags",
          select: "Select Tags To Exclude",
        },
        private_tags: {
          title: "Private Tags",
          select: "Select a Private Tag",
          multi_select: "Select Private Tags"
        },
        exclude_private_tags: {
          title: "Excluded Private Tag | Excluded Private Tags",
          select: "Select Private Tags To Exclude",
        },
        association: 'Association | Associations',
        child_association: 'Child Association | Child Associations',
        first_name: {
          title: "First name"
        },
        middle_name: {
          title: "Middle name"
        },
        last_name: {
          title: "Last name"
        },
        title: {
          title: "Title"
        },
        job_title: {
          title: "Job title"
        },
        display_name: {
          title: "Display name"
        },
        affiliation_id: {
          title: "Affiliation"
        },
        weighting: {
          title: "Weighting"
        },
        color: {
          title: "Color"
        },
        allow_relationship: {
          title: "Allow relationship"
        },
        alias: {
          title: "Alias"
        },
        category: {
          title: "Category"
        }
      },
      placeholders: {
        search_tags: 'Search tags',
        select_user: 'Select User',
      },
      category_type_1: "Article Feature",
      category_type_2: "Article Detail",
      category_type_3: "Media Feature",
      category_type_4: "Organization",
      category_type_5: "Grouping",
      category_type_6: "Source",
      category_type_7: "Media Tag",
      merge: "Merge",
      usage_report: "Usage Report",
      edit: "Edit",
      delete: "Delete",
      delete_tags_with_no_associated_articles: "Delete tags with no associated articles",
      // types: {
      //   article_feature: 'Article Feature',
      //   article_detail: 'Article Detail',
      //   media_feature: 'Media Feature',
      //   organization: 'Organization',
      //   grouping: 'Grouping',
      //   sources: 'Sources',
      //   media_tag: 'Media Tag',
      // },
      sort: {
        alphabetical: "Sort alphabetically"
      },
      list: {
        category: {
          change_to_same_type: "Tags can only be moved within the same category type. Tags from default categories cannot be moved.",
        },
        tag_name: "Tag Name",
        tag_id: "Tag id",
        tag_created_at: "Tag created at",
        associated_articles: "nº associated articles",
        tag_approved: "Tag approved",
        last_updated_at: "Last Approved Update",
        tag_created_by: "Tag created by",
        tag_category_type: "Category Type",
        first_name: "First Name",
        last_name: "Last Name",
        source_approved: "Source approved",
        not_found: "No tags found"
      },
      form: {
        create: {
          title: "Add {resource} Tag",
          save: "Save Tag",
        },
        edit_source: {
          title: "Edit source",
          save: "Save"
        },
        add: {
          message: {
            success: 'Tag added'
          }
        },
        success: {
          category_updated: 'Tag category updated',
          automated_tag_alias_updated: 'Automated tag alias updated successfully'
        },
        errors: {
          default: {
            duplicated: "Tag name already exists",
            error_updating_tags: "Error updating tags"
          },
          source: {
            duplicated: "Source name already exists"
          },
          grouping: {
            duplicated: "Grouping name already exists"
          },
          organization: {
            duplicated: "Organization name already exists",
            error_updating_organization_tag: "Error updating organization tag"
          },
          category_missing: 'Required category is missing | Required categories are missing ({amount})',
          duplicated_tag_alias: 'Automated tags aliases cannot be duplicated'
        },
        filters: {
          tag_by_category: "Tags by Categories",
          tag_by_sub_category: "Sub Categories",
          pages: "Pages"
        },
        bulk: {
          edit_title: "Edit selected tags",
          edit_confirm: "All {selectedLabel} will be updated once you submit.",
          edit_tag_approve: "Tag Approved?",
          merge_title: "Merge {selectedLabel}?",
          merge_confirm: "The merge will combine multiple tags into one unified tag. All articles in the selected tags will move to the unified tag.",
          merge_tag_label: "Merge Tags",
          merge_confirm_duplicated: "Duplicate tags found. Please select the tag to merge."
        },
        import: {
          button: 'Import tags from Insight',
          title: 'Import tags from Insight',
          text: 'This action will copy all active categories and tags from the corresponding Insight project into Project Code categories and tags list. Do you want to continue?',
          success: 'There were no tags to import | 1 tag was imported | {count} tags were imported'
        },
      },
      messages: {
        confirmation: {
          title: 'Confirm Save',
          message: 'Are you sure you want to save?',
        },
        export_associations: {
          success: 'Associations exported successfully',
          error: 'Associations could not be exported',
        }
      },
      tooltips:{
        missing_category: 'Grouping category missing'
      }
    }
  }
}

module.exports.tag = tag;